import { Component, OnInit, inject } from '@angular/core';
import { KnownBusyScopes } from '@sw-processes/shared';
import { BusyService } from '@mosaik/presentation';
import { SurveyService } from '../../services/survey.service';
import { SurveyResult } from '../../models/survey-result.model';
import * as en from '../../../assets/locales/en.json';
import * as fr from '../../../assets/locales/fr.json';
import * as it from '../../../assets/locales/it.json';
import * as de from '../../../assets/locales/de.json';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'sw-processes-survey-result',
  templateUrl: './survey-result.component.html',
  styleUrls: ['./survey-result.component.scss'],
  standalone: false
})
export class SurveyResultComponent implements OnInit {
  private readonly surveyService = inject(SurveyService);
  private readonly busyService = inject(BusyService);
  private readonly translateService = inject(TranslateService);

  private _isLoading: boolean;
  private _isSuccessful: boolean;

  public constructor() {
    this.initTranslations();
    this._isLoading = false;
    this._isSuccessful = false;
  }

  private initTranslations(): void {
    this.translateService.setTranslation('de', de);
    this.translateService.setTranslation('en', en);
    this.translateService.setTranslation('fr', fr);
    this.translateService.setTranslation('it', it);

    const supportedLanguages = ['de', 'en', 'fr', 'it'].filter(x => window.navigator.language.includes(x));
    const lang = supportedLanguages.length > 0 ? supportedLanguages.shift() : 'en';
    this.translateService.setDefaultLang(lang ? lang : 'en');
  }

  public get isLoading(): boolean {
    return this._isLoading;
  }

  public get isSuccessful(): boolean {
    return this._isSuccessful;
  }

  public async ngOnInit(): Promise<void> {
    this._isLoading = true;
    const surveyResult = this.getUrlVarsAsSurveyResult();
    if (this.isSurveyResultValid(surveyResult)) {
      this.busyService.beginScope(KnownBusyScopes.presenter.header, () =>
        this.surveyService
          .survey(surveyResult)
          .then(() => {
            this._isLoading = false;
            this._isSuccessful = true;
          })
          .catch(() => {
            this._isLoading = false;
          })
      );
    } else {
      this._isLoading = false;
    }
  }

  private getUrlVarsAsSurveyResult(): SurveyResult {
    const vars = new SurveyResult();
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (seperator, key, value) => {
      (vars as any)[key] = value;
      return value;
    });
    return vars;
  }

  private isSurveyResultValid(result: SurveyResult): boolean {
    return Object.keys(result).length > 0 && result.hash !== undefined && result.id !== undefined && result.result !== undefined;
  }
}
